/* eslint-disable no-constant-condition */
import styled from "styled-components";
import { useIsDesktop } from "../../../hooks/useMediaQuery.js";
import { useTranslate } from "../../../contexts/languageContext";
import { responsive } from "../../../resources/constantes.json";
import {themes} from "../../../styles/themes";
import { getPartidoInfo } from "../../../commons/js/util";
import React from "react";
import { useNomenclator } from "../../../contexts/nomenclatorContext.js";

const LeyendaPartidos = ({data, sinInfo, totales}) => {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const isDesktop = useIsDesktop();
  const listaPartidos = parseData(data, nomenclator, sinInfo, t, totales);
  return (
      <LeyendaContainer>
         {/* {title && (
           <TitleLeyenda>{title}</TitleLeyenda>
         )} */}
        <ListadoPartidos>
          {listaPartidos.map(_item => (
            <Partido>
              <>
                <PartidoColor color={_item.color}/>
                <PartidoNombre title={_item.nombre}>{_item.nombre}</PartidoNombre>
              </>
            </Partido>
          ))}
        </ListadoPartidos>
      </LeyendaContainer>
  );
};

const parseData = (partotabla, nomenclator, sinInfo, t, totales) => {
  let parsedData;
  const convocatoria = 'act';
  if (sinInfo) {
    parsedData = [
      {
        nombre: t("sinInformacion"),
        color: themes.color.sinInfo,
        carg: "0",
      },
    ];
    return parsedData;
  } else {
    parsedData = [];
      let cand;
      let cargAsignados = 0;
      for (let index = 0; index < partotabla.length; index++) {
        const el = partotabla[index][convocatoria];
        if (el.pvot === '0') continue;
        cargAsignados += Number(el.carg);
        const codpar = el.codpar;
        const par = getPartidoInfo(codpar, nomenclator.partidos);
        cand = {
          color: par.color,
          nombre: par.nombre,
          carg: el.carg,
          vot: el.vot,
          dataTestId: `data.partotabla[${index}].${convocatoria}.carg`,
        };
        // if (!mostrarCandidatos) continue;
        parsedData.push(cand);
      }
      if (cargAsignados < totales) {
        parsedData.push({
          nombre: t("sinAsignar"),
          color: themes.color.sinAsignar,
          carg: "0",
        });
        return parsedData;
      }
      const orderedData = parsedData.sort((a, b) => {
        if (Number(a.carg) > Number(b.carg)) return -1;
        else if (Number(a.carg) === Number(b.carg)) {
          if (Number(a.vot) > Number(b.vot)) return -1;
          else return 1;
        } else return 1;
      });
      return orderedData;
  }
}
const LeyendaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin:0 1rem;
`;

const TitleLeyenda = styled.h2`
  font-family: Lato;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  text-align: left;
  margin: 1rem;
`;

const ListadoPartidos = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: 0 auto;
  grid-gap: 5px 2px;
  width:100%;
`;

const Partido = styled.li`
  display: grid;
  align-items: center;
  grid-template-columns: 10px 1fr;
`;

const PartidoColor = styled.span`
  display:flex;
  width:8px;
  height:8px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

const PartidoNombre = styled.span`
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;


const SLeyendaPartidos = styled(LeyendaPartidos)`
  width: 100%;
`;


export default SLeyendaPartidos;
